import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const firstHalf = categories.slice(0, 7);
  const secondHalf = categories.slice(7);

  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-3">
              <span className="font-heading text-xl font-bold text-primary-600">
                itaobuy<span className="text-accent-500">.team</span>
              </span>
            </Link>
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-4">
              Your trusted hub for itaobuy sheet comparisons, rankings, and comprehensive guides. Helping you make smarter purchasing decisions with verified spreadsheet data.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 text-xs md:text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              Visit Main Platform
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
          </div>

          {/* Categories col 1 */}
          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              Categories
            </h4>
            <ul className="space-y-2">
              {firstHalf.map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories col 2 */}
          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              More Categories
            </h4>
            <ul className="space-y-2">
              {secondHalf.map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/itaobuy-sheet-guide-2026" className="text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Itaobuy Sheet Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  Main Platform
                </a>
              </li>
              <li>
                <a
                  href="#categories"
                  className="text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  All Categories
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} itaobuy.team — Independent Itaobuy Sheet Comparison Hub. All external links open in new tabs.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              Main Site
            </a>
            <Link to="/itaobuy-sheet-guide-2026" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              Guide
            </Link>
            <span className="text-xs text-foreground-400">Updated Daily</span>
          </div>
        </div>
      </div>
    </footer>
  );
}